import gsap from 'gsap';
import { isSafari } from 'shared/lib';
import { SECTIONS_IDS } from 'constants/global';

export const aboutProgramAnimation = cardsContainerRef => () => {
  const mm = gsap.matchMedia();

  const minPageWidthToMobile = isSafari() ? 730 : 740;

  mm.add(
    {
      notMobile: `(min-width: ${minPageWidthToMobile}px)`,
      isMobile: `(max-width: ${minPageWidthToMobile - 1}px)`,
    },
    context => {
      const { notMobile } = context.conditions;
      const endValue = notMobile ? '+=2500' : '+=800';

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `#${SECTIONS_IDS.aboutProgram}`,
          end: endValue,
          scrub: true,
          pin: true,
          pinSpacing: 'padding',
          invalidateOnRefresh: true,
        },
      });

      tl.to({}, { duration: 1 });
      tl.to('#aboutProgram-title', { yPercent: -5, opacity: 0 });
      tl.fromTo('#aboutProgram-text', { yPercent: 5, opacity: 0 }, { yPercent: 0, opacity: 1 });

      tl.to('#aboutProgram-text', { opacity: 0, duration: 0.5 });
      tl.to('#aboutProgram-cards', { opacity: 1, duration: 0.5 });
      tl.to({}, { duration: 0.5 });

      if (notMobile) {
        tl.to(cardsContainerRef.current, {
          x: () => {
            const parent = cardsContainerRef.current.parentElement;
            const style = getComputedStyle(parent);
            const contentWidth =
              parent.offsetWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
            return -(cardsContainerRef.current.scrollWidth - contentWidth);
          },
          ease: 'none',
          duration: 2,
        });
        tl.to({}, { duration: 0.5 });
      }
    },
  );
};
